import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../contexts/LangContext";
import api, { formatApiErrorDetail } from "../lib/api";
import Logo from "../components/Logo";
import { Check } from "lucide-react";

export default function ForgotPassword() {
  const { t } = useLang();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-20 pb-12" data-testid="forgot-page">
      <form onSubmit={submit} className="w-full max-w-md space-y-6" data-testid="forgot-form">
        <Logo size="md" />
        <h1 className="font-serif text-4xl text-navy">{t.auth.forgotTitle}</h1>
        <div className="divider-gold" />
        <p className="text-slate-600 text-sm">{t.auth.forgotSub}</p>

        <div>
          <label className="text-xs uppercase tracking-widest text-slate-500 block mb-2">{t.auth.email}</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full border-b border-slate-300 focus:border-navy outline-none py-3 bg-transparent" data-testid="forgot-email" />
        </div>

        {err && <div className="text-sm text-red-600" data-testid="forgot-error">{err}</div>}
        {sent && (
          <div className="flex items-start gap-2 text-sm text-green-700 bg-green-50 border border-green-200 px-4 py-3" data-testid="forgot-success">
            <Check className="w-4 h-4 mt-0.5 shrink-0" />
            <div>
              <div>{t.auth.forgotSent}</div>
            </div>
          </div>
        )}

        <button type="submit" disabled={loading} className="w-full bg-navy text-white py-4 text-xs uppercase tracking-[0.25em] hover:bg-club-red transition-colors disabled:opacity-60" data-testid="forgot-submit">
          {loading ? "..." : t.auth.forgotSubmit}
        </button>

        <div className="text-sm text-center pt-2">
          <Link to="/login" className="text-slate-500 hover:text-club-red" data-testid="forgot-back-login">← {t.nav.login}</Link>
        </div>
      </form>
    </div>
  );
}
